import OnlineBookingSolutionsLandingWidget from './bootstrap';

// @ts-ignore
window.initOnlineBookingSolutionsLandingWidget = OnlineBookingSolutionsLandingWidget;

export {};
